/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getEnvironment } from 'src/core/utils/api/environment';
import { urlBuilder } from 'src/core/utils/api/urlBuilder';

/**
 * A simple utility function that gets the full URL
 * given a specific asset resource URL.
 * NOTE: Assets url is also hard coded in the
 * index.cshtml file. Read the documentation there
 * for full reasoning on why.
 *
 * @param resourceUrl The url of the asset to get.
 * @returns A full path fof the asset url in the blob.
 */
export const getAssetsUrl = (resourceUrl: string) =>
    urlBuilder()
        .baseUrl(getEnvironment().assetsUrl)
        .resource(resourceUrl)
        .build();
